import translations from './activityTranslations.json';

const escapeRegex = text => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const rules = translations.map(([source, target]) => {
  const keys = [];
  let offset = 0;
  let pattern = '^';
  for (const match of source.matchAll(/%\{(\w+)\}/g)) {
    pattern += escapeRegex(source.slice(offset, match.index)) + '([\\s\\S]+?)';
    keys.push(match[1]);
    offset = match.index + match[0].length;
  }
  pattern += escapeRegex(source.slice(offset)) + '$';
  return { regex: new RegExp(pattern), keys, target,
    specificity: source.replace(/%\{\w+\}/g, '').length };
}).sort((a, b) => b.specificity - a.specificity);

const systemActor = value => {
  if (value === 'Default Policy') return '默认策略';
  if (value === 'Automation System') return '自动化系统';
  if (value.startsWith('Automation System via ')) {
    return `自动化系统（策略：${value.slice(22)}）`;
  }
  return value;
};

// Called only by Activity.vue: preserve stored audit content and user messages.
export const localizeActivity = (content, locale) => {
  if (typeof content !== 'string' || !/^zh(?:[-_](?:CN|Hans))?$/i.test(locale)) return content;
  for (const { regex, keys, target } of rules) {
    const match = content.match(regex);
    if (!match) continue;
    const values = Object.fromEntries(keys.map((key, i) => {
      let value = match[i + 1];
      if (key === 'user_name') value = systemActor(value);
      if (key.endsWith('_priority')) {
        value = { urgent: '紧急', high: '高', medium: '中', low: '低', none: '无' }[value] || value;
      }
      return [key, value];
    }));
    // Single-pass substitution keeps placeholder-like names literal.
    return target.replace(/%\{(\w+)\}/g, (_, key) => values[key]);
  }
  return content;
};
